import type { FC } from 'react';
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import { InitPassword } from 'app/components/pages/PublicApp/InitPassword/InitPassword';
import { ConfigContextProvider } from 'app/context/ConfigContext/ConfigContext';

const PublicAppComponent: FC = () => (
  <ConfigContextProvider>
    <Switch>
      <Route path="/public/init-password" component={InitPassword} />
    </Switch>
  </ConfigContextProvider>
);

export const PublicApp = withRouter(PublicAppComponent);
